import React from "react";
import EmployeeList from "./EmployeeList";

const Employee = () => {
  return (
    <div>
      <EmployeeList />
    </div>
  );
};

export default Employee;
